import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2'
import moment from 'moment'


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  
  export const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: '',
      },
    },
  };
  

const VerticalLoginBarChart = (props) => {
  const labels = props.data.map(obj=>moment(obj.Date).format("DD MMM YY")) 
  const androidCount = props.data.map(obj=>obj.Android); 
  const iosCount = props.data.map(obj=>obj.IOS); 
  const webCount = props.data.map(obj=>obj.Web); 
  
  const data = {
    labels,
    datasets: [
      {
        label: 'android',
        data: androidCount,
        backgroundColor: '#00FF7F',
      },
      {
        label: 'ios',
        data: iosCount,
        backgroundColor: '#B0B0B0',
      },
      {
        label: 'Web',
        data: webCount,
        backgroundColor: '#1E90FF',
      },
    ],
  };

  return (
    <Bar options={options} data={data} />
  )
}

export default VerticalLoginBarChart;